// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"8d4363445ef8538b4fb9","691":"82d3d887c60c75cc15e7"}[chunkId] + ".js";
};